import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var cardAddress = /*#__PURE__*/css(designTokenFonts.body, " color:", colors.neutral.heavy.default, ";");